
import * as React from 'react';


class TestDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.componentName = "[testDropdown.jsx] ";
    }


    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');

        // $("#dropdownMenu2").dropdown();


    }


    render() {
        console.log(this.componentName + 'render');

        return (

            <div>

                <div className="dropdown">
                    <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Dropdown
                    </button>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                        <button className="dropdown-item" type="button">Action</button>
                        <button className="dropdown-item" type="button">Another action</button>
                        <button className="dropdown-item" type="button">Something else here</button>
                    </div>
                </div>

                <hr />

                <div className="dropdown">
                    <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Dropdown with submenu
                    </button>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenu3">
                        <button className="dropdown-item" type="button">Action</button>
                        <button className="dropdown-item" type="button">Another action</button>
                        <button className="dropdown-item" type="button">Something else here</button>



                        <button className="dropdown-item dropdown-toggle" type="button" id="dropdownSubMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            submenu
                            </button>

                        <div className="dropdown-menu" aria-labelledby="dropdownSubMenu">
                            <button className="dropdown-item" type="button">Action</button>
                            <button className="dropdown-item" type="button">Another action</button>
                            <button className="dropdown-item" type="button">Something else here</button>
                        </div>


                    </div>



                </div>




            </div>

        );
    }
}

export default TestDropdown;